import AffiliateMainPage from '@/pages/AffiliateMainPage.vue';
import AffiliateReferralsPage from '@/pages/AffiliateReferralsPage.vue';
import AffiliateReferralDetailPage from '@/pages/AffiliateReferralDetailPage.vue';
import AffiliateTransactionsPage from '@/pages/AffiliateTransactionsPage.vue';
import AffiliatePayoutsPage from '@/pages/AffiliatePayoutsPage.vue';
import AffiliateRulesPage from '@/pages/AffiliateRulesPage.vue';

export default [
  {
    path: '/affiliate',
    name: 'affiliate-main',
    component: AffiliateMainPage,
    meta: { title: 'Партнерская программа' },
  },
  {
    path: '/affiliate/referrals',
    name: 'affiliate-referrals',
    component: AffiliateReferralsPage,
    meta: { title: 'Рефералы - Партнерская программа' },
  },
  {
    path: '/affiliate/referrals/:referralId',
    name: 'affiliate-referral',
    component: AffiliateReferralDetailPage,
    meta: { title: 'Рефералы - Партнерская программа' },
  },
  {
    path: '/affiliate/transactions',
    name: 'affiliate-transactions',
    component: AffiliateTransactionsPage,
    meta: { title: 'Транзакции - Партнерская программа' },
  },
  {
    path: '/affiliate/payouts',
    name: 'affiliate-payouts',
    component: AffiliatePayoutsPage,
    meta: { title: 'Выплаты - Партнерская программа' },
  },
  {
    path: '/affiliate/rules',
    name: 'affiliate-rules',
    component: AffiliateRulesPage,
    meta: { title: 'Правила - Партнерская программа' },
  },
];
